import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';

import AudioGuideModal from '@/components/modal/audio-guide';
import GlobalMask from '@/components/global-mask';

import Timestamp from './timestamp';

import Footer from './footer';
import styles from './style.module.scss';

const RecordBox = (props) => props.visible ? (
  <div className={cls(styles.container)}>
    <div className={cls(styles.content)}>
      <div className={styles.timestamp}>
        <Timestamp
          onTimeout={props.onSend}
          totalTime={props.totalTime}
          heartbeat={props.heartbeat && props.visible}
          loudness={props.loudness}
        />
      </div>
      <div className={styles.footer}>
        <Footer onCancel={props.onCancel} onSend={props.onSend} />
      </div>
      <AudioGuideModal />
    </div>
    <GlobalMask visible />
  </div>
) : null;

RecordBox.propTypes = {
  visible: PropTypes.bool,
  heartbeat: PropTypes.bool,
  onCancel: PropTypes.func,
  onSend: PropTypes.func,
  totalTime: PropTypes.number,
  loudness: PropTypes.number,
};

export default RecordBox;
